var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 50,
    viewBox: "0 0 108 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5548 14.3538C33.1538 6.82911 26.696 0.489574 19.022 0.489574C10.5759 0.489574 6.58828 3.26885 4.17294 8.34454C-10.6016 39.3923 24.471 63.5203 47.4066 41.4571C38.7746 45.9023 27.604 43.1707 26.2417 39.3923C23.9258 31.562 30.8739 17.558 31.5548 14.3538Z",
    fill: "url(#paint0_linear_134_17573)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4066 41.4571C57.424 36.2985 57.6277 18.1373 61.5468 16.7607C57.1395 12.0372 51.8016 10.5409 41.5364 15.3452C38.8188 18.6443 42.044 31.6987 26.2417 39.3923C27.604 43.1708 38.7746 45.9023 47.4066 41.4571Z",
    fill: "url(#paint1_linear_134_17573)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5364 15.3452C51.1447 10.8483 56.4362 11.8715 60.6882 15.8944C60.9789 16.1694 61.2648 16.4585 61.5468 16.7607C65.2624 20.743 68.3165 27.019 73.1038 33.7473C83.0858 37.8218 88.9093 33.8701 88.368 24.0844C82.4612 6.62697 59.7281 -6.7389 41.5364 15.3452Z",
    fill: "url(#paint2_linear_134_17573)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1038 33.748C97.6249 65.5695 124.729 10.0078 94.8954 0.174549C88.9014 -1.05462 82.2591 4.44551 84.3233 9.21903C92.9932 29.2678 87.1875 39.4968 73.1038 33.748Z",
    fill: "url(#paint3_linear_134_17573)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_134_17573",
    x1: 18.9281,
    y1: 2.08324,
    x2: 33.5215,
    y2: 47.7727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B6C1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_134_17573",
    x1: 53.8431,
    y1: 11.4939,
    x2: 44.5,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#966310"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966310"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_134_17573",
    x1: 44.5688,
    y1: 12.585,
    x2: 85.4847,
    y2: 33.4521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB438"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_134_17573",
    x1: 99.3962,
    y1: 2.35673,
    x2: 81.2568,
    y2: 45.1821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966310"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cbfbc3834f67f96965476caf9be0983f.svg";
export { ForwardRef as ReactComponent };